/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const Superscript = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m5.6 5 4.9 5.93L15.4 5H18l-6.2 7.5L18 20h-2.6l-4.9-5.93L5.6 20H3l6.2-7.5L3 5zm15.95 1.58A.8.8 0 0 0 21 5.2a.8.8 0 0 0-.77 1.02l-1.15.33a2 2 0 1 1 3.3.9L20.73 9H23v1h-4V9z" />
  </Icon>
);
